import { createContext } from 'react';

/**
 * Host element for a page-owned full-height sub-nav column, mounted by the nav
 * shell between the icon rail and the header+content column. Lives in its own
 * module so pages can consume it without importing the Amplify-coupled shell.
 */
export const SubNavHostContext = createContext<HTMLElement | null>(null);
